<template>
  <v-dialog :value="value" persistent width="500">
    <v-card color="kbRed">
      <template>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pt-6 d-flex flex-column align-center">
              <v-icon color="white" size="80px">mdi-alert</v-icon>
              <p class="white--text text-center mt-2 mb-0">{{ $t('general.saveTemplateWarning') }}</p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="d-flex align-center justify-center">
          <v-btn
            color="white"
            class="mr-1"
            outlined
            small
            @click="continueWithoutSaving()">
            {{ $t('general.continueWithoutSaving') }}
          </v-btn>

          <v-btn
            class="kbRed--text"
            color="white"
            dark
            small
            @click="saveTemplate()">
            {{ $t('general.saveTemplate') }}
          </v-btn>
        </v-card-actions>
      </template>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  methods: {
    continueWithoutSaving () {
      this.$emit('continueWithoutSaving')
      this.toggleModal()
    },
    saveTemplate () {
      this.$emit('saveTemplate')
      this.toggleModal()
    },
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
